interface Params {
  message: string;
}

export default function validateFrenchPhoneNumber(params: Params) {
  return (_key, newValue: string) => {
    const phoneNumber = newValue;
    /*
     **   ^
     **    (?:(?:\+|00)33|0)    #indicatif
     **    \s*[1-9]             #first number (from 1 to 9)
     **    (?:[\s.-]*\d){8}     #End of the phone number
     **   $
     */

    const regex = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d){8}$/g;
    if (!phoneNumber || regex.test(phoneNumber)) {
      return true;
    }

    return params.message;
  };
}
